import React from 'react';
import AppRoutes from 'routes';
import MetaTagHolder from 'components/MetaTagHolder';

const App = () => {
  console.log(decodeURI('Huy%20Ho%C3%A0ng'));
  return (
    <div className="md:bg-[#555] bg-none min-h-screen overflow-y-auto">
      {window.location.pathname !== '/ket-qua' && <MetaTagHolder />}
      <div className="max-w-none mobile:max-w-sm mx-auto bg-white w-screen">
        <AppRoutes />
      </div>
    </div>
  );
};

export default App;
